module.exports = __webpack_public_path__ + "static/media/bb-marketing-thumbnail-small.08568293.png";